import { render, staticRenderFns } from "./CardNavigationSkeleton.vue?vue&type=template&id=584b9e53"
import script from "./CardNavigationSkeleton.vue?vue&type=script&lang=js"
export * from "./CardNavigationSkeleton.vue?vue&type=script&lang=js"
import style0 from "./CardNavigationSkeleton.vue?vue&type=style&index=0&id=584b9e53&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports